import { gql, useQuery } from "@apollo/client";
import { redirectPropertiesPage } from "types/gql-types";

const QUERY = gql`
  query redirectPropertiesPage {
    redirectPropertiesPage
  }
`;

export const useRedirectPropertiesPageFeature = (): boolean => {
  const query = useQuery<redirectPropertiesPage>(QUERY);

  if (query.loading || query.error || !query?.data?.redirectPropertiesPage) {
    return false;
  }

  return query.data.redirectPropertiesPage;
};
